module.exports = "<div class=\"row\">\n  <div class=\"col-xs-12\">\n\n    <daccs-live-header\n      [ShiftsData]=\"(cashierShifts$ | async) ? (cashierShifts$ | async): null\"\n      [EODData]=\"(EODData$ | async) ? (EODData$ | async): null\">\n    </daccs-live-header>\n\n  </div>\n\n</div>\n\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/daily-recon.component.html
// module id = ../../../../../src/app/views/daily-recon/daily-recon.component.html
// module chunks = main